/** Помощники для регистрации по email: почтовый сервис, опечатки в домене, таймер повторной отправки. */

export const RESEND_COOLDOWN_SEC = 60;

function domainOf(email: string): string {
  const at = email.trim().toLowerCase().lastIndexOf("@");
  return at < 0
    ? ""
    : email
        .trim()
        .toLowerCase()
        .slice(at + 1);
}

/** Ссылка на веб-почту для известных доменов, иначе null. */
export function mailboxUrl(email: string): string | null {
  const d = domainOf(email);
  if (!d) return null;
  if (d === "gmail.com" || d === "googlemail.com") return "https://mail.google.com";
  if (/^yandex\.[a-z]+$/.test(d) || d === "ya.ru") return "https://mail.yandex.ru";
  if (["mail.ru", "list.ru", "bk.ru", "inbox.ru"].includes(d)) return "https://e.mail.ru";
  if (/^(outlook|hotmail|live)\.[a-z.]+$/.test(d)) return "https://outlook.live.com";
  return null;
}

const TYPO_DOMAINS: Record<string, string> = {
  "gmail.gom": "gmail.com",
  "gmail.con": "gmail.com",
  "gmail.co": "gmail.com",
  "gmail.cm": "gmail.com",
  "gmail.om": "gmail.com",
  "gmail.ru": "gmail.com",
  "gmial.com": "gmail.com",
  "gmai.com": "gmail.com",
  "gamil.com": "gmail.com",
  "gmal.com": "gmail.com",
  "gmaill.com": "gmail.com",
  "gnail.com": "gmail.com",
  "mail.ry": "mail.ru",
  "mail.r": "mail.ru",
  "mai.ru": "mail.ru",
  "maill.ru": "mail.ru",
  "yandex.ry": "yandex.ru",
  "yandex.r": "yandex.ru",
  "yadex.ru": "yandex.ru",
  "yandx.ru": "yandex.ru",
  "yandeks.ru": "yandex.ru",
  "hotmial.com": "hotmail.com",
  "hotmal.com": "hotmail.com",
  "hotmail.con": "hotmail.com",
  "outlok.com": "outlook.com",
  "outlook.con": "outlook.com",
  "iclod.com": "icloud.com",
  "icloud.con": "icloud.com",
};

/** Если домен похож на частую опечатку — исправленный адрес, иначе null. */
export function suggestEmailFix(email: string): string | null {
  const trimmed = email.trim();
  const at = trimmed.lastIndexOf("@");
  if (at <= 0) return null;
  const fixed = TYPO_DOMAINS[trimmed.slice(at + 1).toLowerCase()];
  return fixed ? `${trimmed.slice(0, at)}@${fixed}` : null;
}

/** Сколько секунд осталось до повторной отправки (0 — можно отправлять). */
export function cooldownRemaining(
  sentAt: number | null,
  now: number,
  seconds = RESEND_COOLDOWN_SEC,
): number {
  if (sentAt == null) return 0;
  return Math.max(0, Math.ceil((sentAt + seconds * 1000 - now) / 1000));
}

/** Ошибка входа «почта не подтверждена». */
export function isEmailNotConfirmed(err: unknown): boolean {
  if (!err || typeof err !== "object") return false;
  const e = err as { message?: unknown; code?: unknown };
  if (e.code === "email_not_confirmed") return true;
  return typeof e.message === "string" && /email not confirmed/i.test(e.message);
}
